module.exports = __webpack_public_path__ + "img/ZoomGray&Black.589689b1.png";